import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import BBCountryList from '../BBCountryList';
import BBCountryListSwitcher from '../BBCountryListSwitcher';
import { PTItemWithImage } from '../../../02_molecules/Item/ItemWithImage/prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

const BBCountryMap = dynamic(() => import('../BBCountryMap'), { ssr: false });

class BBWhereWeWork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      display: 'map',
    };

    this.onDisplaySwitch = this.onDisplaySwitch.bind(this);
  }

  onDisplaySwitch({ value }) {
    return new Promise((resolve) => this.setState({ display: value }, resolve));
  }

  render() {
    const { title, description, mobileImage, map, list, behaviorSettings } = this.props;
    const { display } = this.state;

    return (
      <div className={generateClassNameByBehaviorSettings(behaviorSettings)}>
        <BBCountryListSwitcher
          title={title}
          description={description}
          image={mobileImage}
          onSwitch={this.onDisplaySwitch}
        />

        <div className={display === 'map' ? 'd-none d-lg-block' : 'd-none'}>
          <BBCountryMap countries={map} height={700} />
        </div>

        <div className={display !== 'map' ? '' : 'd-lg-none'}>
          {list.map((item) => (
            <BBCountryList items={item.items} title={item.title} key={item.title} />
          ))}
        </div>
      </div>
    );
  }
}

BBWhereWeWork.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  mobileImage: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  map: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      nextLink: PropTypes.shape({
        href: PropTypes.string,
        as: PropTypes.string,
      }).isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
      description: PropTypes.string,
    }),
  ),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape(PTItemWithImage)).isRequired,
    }),
  ),
  behaviorSettings: behaviorSettingsProps,
};

BBWhereWeWork.defaultProps = {
  title: '',
  description: '',
  mobileImage: null,
  map: [],
  list: [],
  behaviorSettings: null,
};

export default BBWhereWeWork;
